/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

export const ROUTES = {
  HOME: '/',
  SEARCH: '/search',
  ITEM: '/item/:id',
  STOREFRONT: '/store/:id',

  LOGIN: '/login',
  SIGNUP: '/signup',

  DASHBOARD: '/dashboard',
  LISTINGS: '/dashboard/listings',
  ADD_LISTING: '/dashboard/listings/new',
  EDIT_LISTING: '/dashboard/listings/:id/edit',
  MESSAGES: '/dashboard/messages',
  STOREFRONT_SETTINGS: '/dashboard/store',
  PAYMENTS: '/dashboard/payments',
  ADS: '/dashboard/ads',
  SETTINGS: '/dashboard/settings'
};
